import React from 'react';
import T from 'prop-types';
import {
  TestOrderModeToastContainer,
  TestOrderModeToastClearButton
} from 'routes/App/BookADriver/components/TestOrderModeToast/styles';

const TestOrderModeToast = ({onClose}) => {
  return (
    <TestOrderModeToastContainer>
      <div>TEST ORDER</div>
      <TestOrderModeToastClearButton onClick={onClose}>
        CLEAR
      </TestOrderModeToastClearButton>
    </TestOrderModeToastContainer>
  );
};

TestOrderModeToast.propTypes = {
  onClose: T.func.isRequired
};

export default TestOrderModeToast;
